import { IReviewCardProps } from "@libs/cards/ReviewCard";
import dynamic from "next/dynamic";

const ReviewsQuotes = dynamic(
  async () => await import("@components/icons/ReviewsQuotes"),
  {
    ssr: false,
  }
);
const ReviewerContent = dynamic(
  async () => await import("@libs/cards/components/ReviewCard/ReviewerContent"),
  {
    ssr: false,
  }
);
const DesktopReviewGallery = dynamic(
  async () =>
    await import("@libs/cards/components/ReviewCard/DesktopReviewGallery"),
  { ssr: false }
);

const DesktopReviewCardWithImages = ({
  review,
  headshot,
  reviewer,
  country,
  date,
  images,
}: IReviewCardProps): JSX.Element => {
  return (
    <div className="flex w-full flex-row gap-4">
      <div
        className={`h-[35.25rem] w-full border border-blue-10 ${
          images?.length ? "max-w-[33.125rem]" : "w-full"
        } flex flex-col justify-between rounded-3xl py-8 px-[3.375rem]`}
      >
        <div className="flex flex-col gap-6">
          <div className="flex">
            <ReviewsQuotes />
          </div>
          <div className="flex-grow text-left text-darkgray">{review}</div>
        </div>
        <ReviewerContent
          headshot={headshot}
          reviewer={reviewer}
          country={country}
          date={date}
        />
      </div>
      {images?.length && (
        <DesktopReviewGallery images={images} reviewer={reviewer} />
      )}
    </div>
  );
};

export default DesktopReviewCardWithImages;
